'use client';

import { createContext } from 'react';

export interface ButtonSelectContextType {
  checked: string;
  onClick: (value: string) => void;
  secondFeature?: boolean;
  inStock?: boolean;
  selectFeature?: (value: string) => void;
  variant: any;
  features: string[];
}

export const ButtonSelectContext = createContext<ButtonSelectContextType>({
  checked: '',
  onClick: () => {},
  secondFeature: false,
  inStock: true,
  selectFeature: () => {},
  variant: {},
  features: [],
});
